import { render } from "./PyramidChart.vue?vue&type=template&id=0c7cda0e"
import script from "./PyramidChart.vue?vue&type=script&lang=js"
export * from "./PyramidChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__